import { render, staticRenderFns } from "./FormCentro.vue?vue&type=template&id=30bcfd28&"
import script from "./FormCentro.vue?vue&type=script&lang=js&"
export * from "./FormCentro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports